import React from 'react';

import { Text, Flex } from '@tapresearch/ui/components';
import { CustomBarItemLabelProps } from '@tapresearch/ui/charts';
import { TapAnswer } from 'app/javascript/bundles/insights_platform/api';

export interface CustomBarLabelProps extends CustomBarItemLabelProps {
  answersById: Record<string, TapAnswer['attributes']>;
  usePercentage: boolean;
}

export function CustomBarLabel(props: CustomBarLabelProps) {
  const { answersById, barProps } = props;

  if (!props.barProps) {
    return null;
  }

  return (
    <Flex
      {...{
        position: 'absolute',
        justify: 'space-between',
        px: 5,
        fontWeight: 'medium',
        color: 'gray.900',
        w: 'full',
        left: 0,
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        mt: '-1px',
      }}
    >
      <Text>{answersById[barProps.bar.data.id]?.option_text}</Text>
      <Text>
        {barProps.bar.data.data[barProps.bar.data.id + '_total']}
        {` (${Number(barProps.bar.data.value).toFixed(2)}%)`}
      </Text>
    </Flex>
  );
}

export function getCustomBarLabel({
  answersById,
  usePercentage,
}: {
  answersById: Record<string, TapAnswer['attributes']>;
  usePercentage: boolean;
}) {
  // eslint-disable-next-line react/display-name
  return (props: React.PropsWithChildren<CustomBarLabelProps>) => (
    <CustomBarLabel {...{ ...props, answersById, usePercentage }} />
  );
}
